import React from 'react';
import PropTypes from 'prop-types';

import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnWarningIcon = ({ tooltipContent, customClass = '' }) => {
    return (
        <Tooltip title={tooltipContent} placement="top">
            <div className={`${classes.warningIcon} ${customClass && classes[customClass]}`}>
                <WarningIcon aria-label="warning-icon" />
            </div>
        </Tooltip>
    );
};

OnWarningIcon.propTypes = {
    tooltipContent: PropTypes.string,
    customClass: PropTypes.string
};

export default OnWarningIcon;
